<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.waybill', 2) }}
          <v-btn color="primary" @click="goTo('newWaybill')"> {{ $t('create') }} </v-btn>
          <v-btn color="primary" @click="goTo('importWaybills')" outline> {{ $t('importFile') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-alert :value="true" color="error" icon="warning" outline v-html="$t('waybillsAlert')"></v-alert>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 md4>
                <v-text-field v-model="waybillNumber"
                              append-icon="search"
                              :label="$t('attrs.number')"
                              @click:append="fetch"
                              ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-select v-model="carrierId"
                          :items="carriers"
                          item-value="id"
                          item-text="name"
                          :label="$tc('models.carrier')"
                          clearable
                          @change="fetch"
                          ></v-select>
              </v-flex>

              <v-flex xs12 md4>
                <v-select v-model="serviceId"
                          :items="filteredServices"
                          item-value="id"
                          item-text="name"
                          :label="$tc('models.service')"
                          :disabled="!carrierId"
                          clearable
                          @change="fetch"
                          ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-data-table class="elevation-1"
                      :headers="headers"
                      :items="items"
                      :loading="loading"
                      :total-items="totalItems"
                      :pagination.sync="pagination"
                      :no-data-text="$t('noDataAvailable')">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <td> {{ props.item.number }} </td>
            <td>
              <span v-if="props.item.carrier">
                {{ props.item.carrier.name }}
              </span>
            </td>
            <td>
              <span v-if="props.item.service">
                {{ props.item.service.name }}
              </span>
            </td>
            <td>
              <span v-if="props.item.shipment">
                {{ props.item.shipment.id }}
              </span>
            </td>
            <td> {{ props.item.created_at | date }} </td>
            <td class="pa-0 pr-2 text-xs-right">
              <v-btn color="red" flat icon @click="destroy(props.item)" v-can:destroy="'Waybill'" v-if="!props.item.deleted_at">
                <font-awesome-icon icon="times"></font-awesome-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Waybill from '@/client/waybill'
import Carrier from '@/client/carrier'
import Service from '@/client/service'

export default {
  name: 'WaybillsView',

  props: {},

  data () {
    return {
      headers: [
        { text: this.$t('attrs.number'), align: 'left', sortable: true, value: 'number' },
        { text: this.$tc('models.carrier'), align: 'left', sortable: true, value: 'carrier.name' },
        { text: this.$tc('models.service'), align: 'left', sortable: true, value: 'service.namce' },
        { text: this.$tc('models.shipment'), align: 'left', sortable: true, value: 'shipment.id' },
        { text: this.$t('attrs.created_at'), align: 'left', sortable: true, value: 'created_at' },
        { text: '', align: 'left', sortable: false, value: '', width: '5%' }
      ],
      items: [],
      totalItems: 0,
      pagination: {
        rowsPerPage: 10
      },
      loading: false,
      waybillNumber: '',
      carrierId: '',
      serviceId: '',

      carriers: [],
      services: []
    }
  },

  components: {
  },

  computed: {
    filteredServices () {
      if (!this.carrierId) { return [] }

      return this.services.filter(o => Number(o.carrier_id) === Number(this.carrierId))
    }
  },

  methods: {
    async fetch () {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      const where = {}

      if (this.waybillNumber) { where.number = this.waybillNumber }
      if (this.carrierId) { where.carrier_id = this.carrierId }
      if (this.serviceId) { where.service_id = this.serviceId }
      let order = ''
      if (sortBy) {
        order = `${sortBy} ${descending ? 'desc' : 'asc'}`
      }

      this.items = await Waybill.all({
        page,
        per_page: rowsPerPage,
        where,
        include: ['carrier', 'service', 'shipment'],
        order
      })
      this.totalItems = this.items.pagination.total_objects
      this.loading = false
    },

    async destroy (waybill) {
      try {
        await Waybill.destroyById(waybill.id)
      } catch (err) {
        // empty
      }
      this.fetch()
    }
  },

  watch: {
    pagination: {
      handler () {
        this.fetch()
      },
      deep: true
    }
  },

  async mounted () {
    this.fetch()
    this.carriers = await Carrier.all({ per_page: 2000 })
    this.services = await Service.all({ per_page: 2000 })
  }
}
</script>
